import {
    FieldComponent as SourceFieldComponent,
} from 'SourceComponent/Field/Field.component';
import React from 'react';
import './Field.override.style';
import FieldSelectContainer from '@scandipwa/scandipwa/src/component/FieldSelect';

export class FieldComponent extends SourceFieldComponent {
    renderSelect() {
        const {
            attr,
            events,
            setRef,
            options,
            isDisabled = false,
            changeValueOnDoubleClick,
            isSortSelect,
        } = this.props;

        return (
            <FieldSelectContainer
                attr={attr}
                events={events}
                options={options}
                setRef={setRef}
                isDisabled={isDisabled}
                isSortSelect={isSortSelect}
                changeValueOnDoubleClick={changeValueOnDoubleClick}
            />
        );
    }

    //#region INPUT TYPE RENDER
    renderDefaultInput() {
        const {
            type, setRef, attr, events, isDisabled, value
        } = this.props;

        return (
            <input
                ref={(elem) => setRef(elem)}
                disabled={isDisabled}
                type={type}
                {...attr}
                {...events}
                value={value}
            />
        );
    }
}

export default FieldComponent;
